import { render, staticRenderFns } from "./IconButtonSitecore.vue?vue&type=template&id=354a14a2"
import script from "./IconButtonSitecore.vue?vue&type=script&lang=js"
export * from "./IconButtonSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports